<template>
    <div class="report__builder_execute">
        <div class="report__builder_execute_header">
            <view-actions
                :title="reportName ? `Report: ${reportName}` : 'Generated report'"
                :cancel-button-active="false"
                :custom-button-animate-loading="!isRouteExecuteResolved"
                :custom-button-animate-loading-event-name="'generate-report-csv'"
                :custom-button-active="true"
                :custom-button-text="isRouteExecuteResolved ? 'Back' : 'Generate CSV'"
                :submit-button-active="!isRouteExecuteResolved"
                :submit-button-text="'Edit report'"
                @emit-submit="redirectToEditReport"
                @emit-custom="handleCustomAction"
            />
        </div>
        <div class="report__builder_execute_main">
            <div class="container">
                <template v-if="reportDescription">
                    <component-title :size="'small'">Description:</component-title>
                    <component-text>{{ reportDescription }}</component-text>
                </template>
                <template v-if="reportBuilderGeneratedReportDataLength >= 500 && reportId">
                    <component-note
                        :class="'report__builder_execute_main_note'"
                    >This report contains too many records to show on page, only the first 500 rows are displayed. <br>To see the full report click <component-button
                            :name="'report-builder-execute-generate-csv'"
                            :text="true"
                            @click="performGenerateCSV"
                        >Generate CSV.</component-button>
                    </component-note>
                </template>
                <report-table
                    :data="reportBuilderGeneratedReport"
                    :columns-view="false"
                    :filters="false"
                />
            </div>
        </div>
        <a
            class="report__builder_execute_hiddenlink hidden"
            id="download-report-csv"
        ></a>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ReportTable from '@/components/ebs/reports/ReportTable'
import ComponentText from '@/components/default/shared/ComponentText'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentNote from '@/components/default/shared/ComponentNote'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'report-builder-execute',
  components: { ComponentButton, ComponentNote, ComponentTitle, ComponentText, ReportTable, ViewActions },
  computed: {
    isRouteExecuteResolved () {
      return this.$route.name === 'ebs-report-builder-execute-resolved'
    },
    reportId () {
      return this.$store.getters.getEbsReportBuilderId
    },
    reportUpdatedAt () {
      return this.$store.getters.getEbsReportBuilderUpdatedAt
    },
    reportName () {
      return this.$store.getters.getEbsReportBuilderName
    },
    reportDescription () {
      return this.$store.getters.getEbsReportBuilderDescription
    },
    reportBuilderGeneratedReport () {
      return this.$store.getters.getEbsReportBuilderGeneratedReport
    },
    reportBuilderGeneratedReportDataLength () {
      return this.reportBuilderGeneratedReport.data.length
    }
  },
  methods: {
    allowRedirectBeforeRouteLeave () {
      this.$eventBus.$emit('report-builder-submit')
    },
    //
    reportStopEdit () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-report-list' })
    },
    redirectToEditReport () {
      this.$router.push({ name: 'ebs-report-builder-edit', params: { id: this.reportId } })
    },
    redirectToReportDashboard () {
      this.$router.push({ name: 'ebs-report-dashboard-show' })
    },
    handleCustomAction () {
      if (this.isRouteExecuteResolved) {
        this.redirectToReportDashboard()
      } else {
        this.performGenerateCSV()
      }
    },
    performGenerateCSV () {
      const routeName = this.$route.name
      const routeReportId = this.$route.params.reportId
      const routeResultId = this.$route.params.resultId
      let dispatchName
      let dispatchParams

      if (routeName === 'ebs-report-builder-execute-scheduled') {
        dispatchName = 'ebsReportBuilderGenerateScheduledReportCSV'
        dispatchParams = { reportId: routeReportId, resultId: routeResultId, reportName: this.reportName }
      } else {
        dispatchName = 'ebsReportBuilderGenerateDefinedReportCSV'
        dispatchParams = { id: this.reportId, name: this.reportName }
      }

      this.$store.dispatch(dispatchName, dispatchParams).finally(() => {
        this.$eventBus.$emit('stop-generate-report-csv')
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportbuilderexecute.scss";
</style>
